// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZVe44","col":"styles_col__2Cfls","actions":"styles_actions__eHPUa","conflict":"styles_conflict__3XnVF"};